export const monthMap = {
  0: "J A N",
  1: "F E B",
  2: "M A R",
  3: "A P R",
  4: "M A Y",
  5: "J U N",
  6: "J U L",
  7: "A U G",
  8: "S E P",
  9: "O C T",
  10: "N O V",
  11: "D E C",
}

export const timezoneMap = {
  "America/New_York": "ET",
  "America/Chicago": "CT",
  "America/Denver": "MT",
  "America/Los_Angeles": "PT",
  "America/Phoenix": "MT",
  "America/Anchorage": "AKT",
  "Pacific/Honolulu": "HST",
  "America/Adak": "HST",
  "Pacific/Midway": "HST",
  "Pacific/Pago_Pago": "HST",
  "Pacific/Niue": "HST",
  "Pacific/Rarotonga": "HST",
  "Pacific/Tahiti": "HST",
  "Pacific/Marquesas": "HST",
  "Pacific/Gambier": "HST",
  "Pacific/Pitcairn": "HST",
  "Pacific/Fiji": "FJT",
  "Pacific/Chatham": "CHAST",
  "Pacific/Apia": "WST",
  "Pacific/Guadalcanal": "SBT",
  "Pacific/Fakaofo": "TKT",
  "Pacific/Tongatapu": "TOT",
  "Pacific/Funafuti": "TVT",
  "Pacific/Kwajalein": "MHT",
  "Pacific/Nauru": "NRT",
  "Pacific/Palau": "PWT",
  "Pacific/Kosrae": "KOST",
  "Pacific/Ponape": "PONT",
  "Pacific/Noumea": "NCT",
  "Pacific/Efate": "VUT",
  "Pacific/Wallis": "WFT",
  "Pacific/Auckland": "NZST",
  "Pacific/Chatham": "CHAST",
  "Pacific/Enderbury": "PHOT",
  "Pacific/Tongatapu": "TOT",
  "Pacific/Kiritimati": "LINT",
  "Pacific/Easter": "EAST",
  "Pacific/Galapagos": "GALT",
  "Pacific/Fiji": "FJT",
  "Pacific/Funafuti": "TVT",
  "Pacific/Kwajalein": "MHT",
  "Pacific/Nauru": "NRT",
  "Europe/London": "GMT",
  "Europe/Paris": "CET",
  "Europe/Berlin": "CET",
  "Europe/Amsterdam": "CET",
  "Europe/Athens": "EET",
  "Europe/Bucharest": "EET",
  "Europe/Helsinki": "EET",
  "Europe/Istanbul": "EET",
  "Europe/Moscow": "MSK",
  "Europe/Riga": "EET",
  "Europe/Sofia": "EET",
  "Europe/Tallinn": "EET",
  "Europe/Vilnius": "EET",
  "Europe/Zurich": "CET",
  "Europe/Kiev": "EET",
  "Europe/Minsk": "MSK",
  "Europe/Warsaw": "EET",
  "Europe/Budapest": "EET",
  "Europe/Chisinau": "EET",
  "Europe/Tiraspol": "EET",
  "Europe/Uzhgorod": "EET",
  "Europe/Zaporozhye": "EET",
  "Europe/Kiev": "EET",
  "Europe/Simferopol": "EET",
  "Europe/Sofia": "EET",
  "Europe/Tallinn": "EET",
  "Europe/Vilnius": "EET",
  "Europe/Zurich": "EET",
  "Europe/Kiev": "EET",
  "Europe/Minsk": "MSK",
  "Europe/Rome": "CET",
  "Etc/GMT": "GMT",
  "Etc/GMT+1": "CET",
  "Etc/UTC": "UTC",
}
